import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPromptSuggestion: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="prompt-suggestion, auto-prompt"><path d="M6.4 2H5.6L4.6 4.6L2 5.6V6.4L4.6 7.4L5.6 10H6.4L7.4 7.4L10 6.4V5.6L7.4 4.6L6.4 2Z" fill="currentColor"/><path d="M18 4.5L21.5 8L9.75 19.75L5.75 20.25L6.25 16.25L18 4.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M15 8L18 11" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
};

export default IconPromptSuggestion;
